import { useEffect } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { useLocation } from 'react-router-dom';
import { QUERY_KEYS } from './useApplications';

export const useDataRefresh = () => {
  const queryClient = useQueryClient();
  const location = useLocation();

  // Refresh data when location changes (navigation)
  useEffect(() => {
    const refreshData = () => {
      queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.APPLICATIONS] });
      queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.MY_APPLICATIONS] });
    };

    // Refresh data on route change
    refreshData();
  }, [location.pathname, queryClient]);

  // Listen for login events to refresh data
  useEffect(() => {
    const handleStorageChange = (e) => {
      if (e.key === 'token' && e.newValue) {
        // Token was set (login occurred)
        refreshAllData();
      }
    };

    window.addEventListener('storage', handleStorageChange);
    return () => window.removeEventListener('storage', handleStorageChange);
  }, [queryClient]);

  // Manual refresh function
  const refreshAllData = () => {
    queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.APPLICATIONS] });
    queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.MY_APPLICATIONS] });
    queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.TL_USERS] });
    queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.ARM_USERS] });
  };

  return { refreshAllData };
};